import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import styled from 'styled-components';
import { neutralColors } from '../../styles/colors/colors.js';

var circleSizeMap = {
  xxs: 10,
  xs: 16,
  sm: 24,
  md: 32,
  lg: 40
};
var Circle = styled.div.withConfig({
  displayName: "Circle",
  componentId: "sc-51xu4f-0"
})(function (_ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? "div" : _ref$as,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    theme = _ref.theme;
  return _objectSpread({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "100%",
    overflow: "hidden",
    backgroundColor: neutralColors.smoke,
    color: neutralColors.white,
    border: "none",
    height: circleSizeMap[size],
    width: circleSizeMap[size],
    "&:focus": {
      boxShadow: "0 0 0 2px ".concat(neutralColors.white, ", 0 0 0 4px ").concat(theme.CTAColors.primaryVariant),
      outline: "none"
    }
  }, as === "button" ? {
    padding: 0,
    "&:hover": {
      cursor: "pointer",
      boxShadow: "0 0 0 2px ".concat(neutralColors.white, ", 0 0 0 4px ").concat(theme.CTAColors.primaryVariant)
    }
  } : {});
});
Circle.displayName = "Circle";

export { Circle, circleSizeMap };
